export const icmp = (a: string, b: string): number =>
  a.toLowerCase().localeCompare(b.toLowerCase());
